"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserCommitment = void 0;
const instalmentPlanTextFormatter_1 = __importDefault(require("./instalmentPlanTextFormatter"));
const initializeUseCurrency_1 = __importDefault(require("./initializeUseCurrency"));
class UserCommitment {
  commitment;
  toCurrency;
  constructor(_ref) {
    let {
      commitment
    } = _ref;
    this.commitment = commitment;
    this.toCurrency = this.initUseCurrency().toCurrency;
  }
  getTime(date) {
    return new Date(date).getTime();
  }
  orderByDueDate(payments) {
    let orderBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "asc";
    return [...payments].sort((_ref2, _ref3) => {
      let {
        dueDate: a
      } = _ref2;
      let {
        dueDate: b
      } = _ref3;
      if (orderBy === "desc") return this.getTime(b) - this.getTime(a);
      return this.getTime(a) - this.getTime(b);
    });
  }
  get isOneOffInvestment() {
    return !this.commitment.instalmentPlan ? true : false;
  }
  totalConfirmedInstalmentPayments() {
    const {
      instalmentPaymentSet
    } = this.commitment;
    return instalmentPaymentSet.paymentsConfirmed.reduce((acc, item) => acc + (item.amountPaid || 0), 0);
  }
  totalConfirmedOneOffPayments() {
    const {
      oneOffPaymentSet
    } = this.commitment;
    return oneOffPaymentSet.paymentsConfirmed.reduce((acc, item) => acc + (item.amountPaid || 0), 0);
  }
  get totalCommitment() {
    if (!this.commitment) return 0;
    return this.totalConfirmedInstalmentPayments() + this.totalConfirmedOneOffPayments();
  }
  get totalTransferred() {
    const {
      instalmentPaymentSet: {
        paymentsConfirmed
      }
    } = this.commitment;
    const totalAmountPaid = paymentsConfirmed?.reduce((acc, curr) => {
      return acc + (curr.amountPaid || 0);
    }, 0) || 0;
    return totalAmountPaid;
  }
  initUseCurrency() {
    return (0, initializeUseCurrency_1.default)(this.commitment.currency);
  }
  get instalmentBreakdown() {
    return (0, instalmentPlanTextFormatter_1.default)({
      amount: this.commitment.instalmentPlanAmount || 0,
      instalmentName: this.commitment.instalmentPlan?.name,
      maxPaymentMonths: this.commitment.maxPaymentMonths,
      toCurrency: this.toCurrency
    });
  }
  get instalmentPlanProgress() {
    const {
      paymentsPending,
      paymentsConfirmed,
      paymentsDue
    } = this.commitment.instalmentPaymentSet;
    const totalPending = paymentsPending.length + paymentsConfirmed.length + paymentsDue.length;
    return `${this.commitment.instalmentPaymentSet.paymentsConfirmed.length} / ${totalPending}`;
  }
  get instalmentPlan() {
    const hasInstalmentPlan = !!this.commitment?.instalmentPlan?.name;
    const planName = this?.commitment?.instalmentPlan?.name === "MONTHLY" ? "monthly" : "quarterly";
    const plan = hasInstalmentPlan ? planName : null;
    return plan;
  }
  get currency() {
    return this.commitment.currency;
  }
  getNextDue() {
    const {
      instalmentPaymentSet,
      oneOffPaymentSet
    } = this.commitment;
    let allDue = instalmentPaymentSet.paymentsDue.map(item => ({
      amount: item.amountDue,
      dueDate: item.dueAt,
      title: "Recurring Amount",
      type: "Monthly Instalment"
    }));
    if (oneOffPaymentSet.paymentDue) {
      allDue = [...allDue, {
        amount: oneOffPaymentSet.paymentDue.amountDue,
        dueDate: oneOffPaymentSet.paymentDue.dueAt,
        title: "One-Off Transfer",
        type: "One-Off Transfer"
      }];
    }
    const orderedDueItems = this.orderByDueDate(allDue);
    return orderedDueItems;
  }
  get nextDue() {
    return this.getNextDue();
  }
}
exports.UserCommitment = UserCommitment;